import React, { createContext, useMemo } from 'react';
import type { ReactNode } from 'react';

type PriceContextProps = {
  currency: string | null;
  locale: string | null;
  showCurrencySign: boolean;
};

export const PriceContext = createContext<PriceContextProps>({
  currency: null,
  locale: null,
  showCurrencySign: true
});

type ProviderProps = {
  children: ReactNode;
  currency: string;
  locale: string;
  showCurrencySign?: boolean;
};

export const PriceProvider = ({ currency, locale, showCurrencySign = true, children }: ProviderProps) => {
  const value = useMemo(() => ({ currency, showCurrencySign, locale }), [currency, showCurrencySign, locale]);

  return <PriceContext.Provider value={value}>{children}</PriceContext.Provider>;
};
